import Head from "next/head";
import React, { FC } from "react";

interface IProps {
  title: string;
}

const Meta: FC<IProps> = ({ title }) => (
  <Head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="sentry-trace" content="{{ span.toSentryTrace() }}" />
    <meta name="baggage" content="{{ serializeBaggage(span.getBaggage()) }}" />
    <title>{title}</title>
  </Head>
);

export default Meta;
